import { createStyles, makeStyles, Theme, LinearProgress } from '@material-ui/core';

export const FormProgress = ({ completionRate }: { completionRate: number }) => {
  const classes = useStyles();

  return (
    <LinearProgress
      variant="determinate"
      value={completionRate}
      classes={{
        root: classes.progress,
        bar:
          completionRate >= 100
            ? classes.barGreen
            : completionRate >= 20
            ? classes.barYellow
            : classes.barRed,
      }}
    />
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    progress: {
      width: '100%',
      height: 12,
      borderRadius: 8,
      backgroundColor: theme.palette.background.default,
    },
    barGreen: {
      backgroundImage: `linear-gradient(270deg, ${theme.palette.success.main} 100%)`,
    },
    barYellow: {
      backgroundImage: `linear-gradient(270deg, ${theme.palette.warning.main} 100%)`,
    },
    barRed: {
      backgroundImage: `linear-gradient(270deg, ${theme.palette.error.main} 100%)`,
    },
  })
);
